/**
 * 크롬 탭이 많아졌을 때의 자리 실험.
 * 저장하지 않는다. 「원래대로」를 누르면 실제 열린 플랜으로 돌아온다.
 */
import { useSyncExternalStore } from "react";

export type TabLabCount = 5 | 10 | 20;

let count: TabLabCount | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export function tabLabCount(): TabLabCount | null {
  return count;
}

export function setTabLabCount(next: TabLabCount | null) {
  if (count === next) return;
  count = next;
  emit();
}

export function subscribeTabLab(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useTabLabCount(): TabLabCount | null {
  return useSyncExternalStore(subscribeTabLab, tabLabCount, tabLabCount);
}

export function labPlanTabs(total: TabLabCount): { id: string; name: string }[] {
  return Array.from({ length: total }, (_, index) => {
    const n = index + 1;
    return { id: `lab-${n}`, name: `플랜 ${n}` };
  });
}
